import { combineReducers } from 'redux';
import auth, { IAuthState } from './authentication';
import locale, { ILocaleState } from './locale';
import config, { IConfigState } from './config';
import breadcrumb, { IBreadcrumbState } from './breadcrumb';

import monitoring, { IMonitoringState } from './monitoring';
import okkoPay, { IOkkoPayState } from './okkoPay';
import site, { ISiteState } from './site';
import store, { IStoreState } from './store';
import menu, { IMenuState } from './menu';
import order, { IOrderState } from './order';
import boltPim, { IBoltPimState } from './boltPim';

export interface IRootState {
    auth: IAuthState;
    locale: ILocaleState;
    config: IConfigState;
    breadcrumb: IBreadcrumbState;

    monitoring: IMonitoringState;
    okkoPay: IOkkoPayState;
    site: ISiteState;
    store: IStoreState;
    menu: IMenuState;
    order: IOrderState;
    boltPim: IBoltPimState;
}

// todo add reducers here
export default combineReducers<IRootState>({
    auth,
    locale,
    config,
    breadcrumb,

    monitoring,
    okkoPay,
    site,
    store,
    menu,
    order,
    boltPim,
});
